import Base from '../core/Base';
import { getAppConfig } from 'larasnap';

/* global google, gapi */

export default class extends Base {
    _pickerApiLoaded = false;
    _oauthToken = null;

    constructor(props) {
        super();

        this.setProps({
            root_folder_enabled: true,
            upload_enabled: false,
            upload_label: 'Upload',
            upload_folder_id: null,
            folders_only: false,
            ...getAppConfig('google.picker'),
            ...props,
        });
    }

    show() {
        gapi.load('auth2', this.onAuthApiLoad.bind(this));
        gapi.load('picker', this.onPickerApiLoad.bind(this));
        return this;
    }

    onAuthApiLoad() {
        const { client_id, scope } = this._props;
        gapi.auth2.authorize(
            { client_id, scope },
            this.handleAuthResult.bind(this),
        );
    }

    onPickerApiLoad() {
        this._pickerApiLoaded = true;
    }

    handleAuthResult(authResult) {
        if (authResult && !authResult.error) {
            this._oauthToken = authResult.access_token;
            this.createDialog();
        }
    }

    addView(picker, { parentFolderId, label }) {
        const view = new google.picker.DocsView()
            .setSelectFolderEnabled(true)
            .setIncludeFolders(true)
            .setParent(parentFolderId)
            .setLabel(label);

        if (this._props.folders_only) {
            view.setMimeTypes('application/vnd.google-apps.folder');
        }

        picker.addView(view);
    }

    createDialog() {
        if (!this._pickerApiLoaded) {
            console.error(
                'Drive Picker Problem, this._pickerApiLoaded is not set',
            );
        }

        if (this._pickerApiLoaded && this._oauthToken) {
            const picker = new google.picker.PickerBuilder();

            if (this._props.folders_only) {
                picker.setTitle('Select a folder');
            }

            const props = this._props;

            props.folders.forEach(folder => {
                this.addView(picker, {
                    label: folder.label,
                    parentFolderId: folder.folder_id,
                });
            });

            if (props.root_folder_enabled) {
                this.addView(picker, {
                    label: props.root_folder_label,
                    parentFolderId: props.root_folder_id,
                });
            }

            if (props.upload_enabled) {
                picker.addView(
                    new google.picker.DocsUploadView()
                        .setParent(props.upload_folder_id)
                        .setLabel(props.upload_label),
                );
            }

            picker.setOAuthToken(this._oauthToken);
            //picker.setDeveloperKey(developerKey). // This causes an error and is apparently unnecessary with an oauth token
            picker.setCallback(this.pickerCallback.bind(this));
            picker.build().setVisible(true);
        }
    }

    pickerCallback(data) {
        if (
            data[google.picker.Response.ACTION] === google.picker.Action.PICKED
        ) {
            const doc = data[google.picker.Response.DOCUMENTS][0];

            //const url = doc[google.picker.Document.URL];

            if (typeof this._props.on_select === 'function') {
                this._props.on_select(doc);
            }
        }
    }
}
